/**
 * MissingFieldsDetails — Zod schema for the `errorDetails` JSON column on
 * `dual_write_events` rows when `errorCode` is `MISSING_FIELDS` or
 * `MISSING_REQUIRED_FIELDS`.
 *
 * Producer: `src/services/v4-ingestion.ts` (MISSING_FIELDS warning path) and
 * `src/services/dual-write.ts` (enrichment with `legacyPresent`).
 *
 * Consumer: admin dual-write diagnostics UI (ErrorDetailView, WarningsTab,
 * warningRules). Consumers parse just-in-time because `DualWriteEvent.errorDetails`
 * is typed loosely (`Record<string, unknown>`) to accommodate other error codes.
 */

import { z } from 'zod';

export const MissingFieldEntrySchema = z.object({
  field: z.string(),
  type: z.string().optional(),
  reason: z.string().optional(),
  source: z.string().optional(),
  legacyPresent: z.boolean().optional(),
});

export const MissingFieldsDetailsSchema = z.object({
  missing: z.array(MissingFieldEntrySchema),
});

export type MissingFieldEntry = z.infer<typeof MissingFieldEntrySchema>;
export type MissingFieldsDetails = z.infer<typeof MissingFieldsDetailsSchema>;
